import OrderSummary from './OrderSummary';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withCountry from '../../../hocs/withCountry';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import { trackViewOrderClick } from '../../../../analytics/category/account';

const enhance = compose(
  withCountry,
  withProps(({ number, href, country, state }) => ({
    href: href || localiseUrl(country, `/account/orders/${number}`),
    handleOnClick: () => trackViewOrderClick(state)
  })),
);

export default enhance(OrderSummary);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/OrderSummary/index.js